// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `geo-search {
  font-family: var(--text-font);
}
geo-search .geo-search {
  height: initial;
  background-color: var(--motes-off-white);
  padding: var(--motes-padding);
  box-sizing: border-box;
  border-radius: var(--border-radius);
  width: 450px;
}
geo-search .geo-search .address-input {
  position: relative;
  height: 40px;
}
geo-search .geo-search .address-input .input {
  width: 100%;
  border-radius: var(--border-radius);
  border: solid 1px var(--motes-lighter-gray);
  background-color: var(--motes-white);
  padding: var(--motes-padding);
  box-sizing: border-box;
  font-size: 16px;
}
geo-search .geo-search .address-input .input input {
  border: none;
  background-color: transparent;
  width: calc(100% - 45px);
}
geo-search .geo-search .address-input svg-icon {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  display: flex;
  align-items: center;
  margin: 0 var(--element-spacing);
}
geo-search .geo-search mini-loading {
  display: flex;
  justify-content: center;
  padding-right: 40px;
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
}
geo-search .geo-search .drawer {
  padding: 0 var(--motes-padding);
  overflow: hidden;
  max-height: 0;
  transition: 0.3s max-height;
}
geo-search .geo-search .drawer.open {
  transition: 0.3s max-height 0.3s;
  max-height: 600px;
}
geo-search .geo-search .drawer .drawer-item {
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  border-radius: var(--border-radius);
  padding: var(--motes-padding);
  background-color: inherit;
  transition: 0.2s background-color;
  cursor: pointer;
}
geo-search .geo-search .drawer .drawer-item:first-of-type {
  margin-top: var(--motes-padding);
}
geo-search .geo-search .drawer .drawer-item.active-address {
  background-color: #d4d4d4;
}
geo-search .geo-search .drawer .drawer-item svg-icon[name=destination] {
  margin-right: 4px;
}
geo-search .geo-search .drawer .drawer-item button {
  background-color: transparent;
}
geo-search .geo-search .drawer .coords-container {
  cursor: default;
}
geo-search .geo-search .drawer .coords-container button {
  display: flex;
  align-items: center;
  font-size: 12px;
  border: none;
  padding: 0;
  font-family: var(--text-font);
  cursor: pointer;
}
geo-search .geo-search .drawer .coords-container .coords {
  display: flex;
  justify-content: space-between;
  margin-top: var(--motes-padding);
  align-items: center;
  padding: var(--motes-padding);
  background-color: var(--motes-lighter-gray);
  border-radius: var(--border-radius);
}
geo-search .geo-search .drawer .coords-container .coords input {
  width: calc(50% - 16px);
  height: 43px;
  border: solid 1px var(--motes-lighter-gray);
  background-color: var(--motes-white);
  border-radius: var(--border-radius);
  padding: var(--motes-padding);
  box-sizing: border-box;
  /* Hide arrows from Chrome, Safari, Edge, Opera */
  /* Hide arrows from Firefox */
}
geo-search .geo-search .drawer .coords-container .coords input::-webkit-outer-spin-button, geo-search .geo-search .drawer .coords-container .coords input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
geo-search .geo-search .drawer .coords-container .coords input[type=number] {
  -moz-appearance: textfield;
}
geo-search .geo-search .drawer .coords-container .coords svg-icon {
  font-size: 16px;
}
geo-search .geo-search .drawer .coords-container .coords svg-icon.hide {
  opacity: 0;
  pointer-events: none;
  cursor: default;
}
geo-search .geo-search .drawer .coords-container .tip {
  font-size: 12px;
  line-height: 1;
  margin: 10px 0 0 0;
}
geo-search .geo-search .drawer .coords-container .error {
  margin-bottom: 0;
  font-size: 12px;
  color: var(--motes-light-red);
}
geo-search .geo-search svg-icon {
  color: var(--motes-black);
  transition: 0.2s;
  font-size: 16px;
}
geo-search .geo-search svg-icon.button {
  cursor: pointer;
}
geo-search .geo-search svg-icon.button:hover {
  transform: scale(1.1);
}
geo-search .geo-search svg-icon[name=x] {
  font-size: 14px;
}
geo-search .geo-search svg-icon span {
  display: flex;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/geo-search/geo-search.component.scss"],"names":[],"mappings":"AAAA;EACI,6BAAA;AACJ;AACI;EACI,eAAA;EACA,wCAAA;EACA,6BAAA;EACA,sBAAA;EACA,mCAAA;EACA,YAAA;AACR;AACQ;EACI,kBAAA;EACA,YAAA;AACZ;AACY;EACI,WAAA;EACA,mCAAA;EACA,2CAAA;EACA,oCAAA;EACA,6BAAA;EACA,sBAAA;EACA,eAAA;AAChB;AACgB;EACI,YAAA;EACA,6BAAA;EACA,wBAAA;AACpB;AAGY;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,gCAAA;AADhB;AAKQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;AAHZ;AAMQ;EACI,+BAAA;EACA,gBAAA;EACA,aAAA;EACA,2BAAA;AAJZ;AAMY;EACI,gCAAA;EACA,iBAAA;AAJhB;AAOY;EACI,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,mCAAA;EACA,6BAAA;EACA,yBAAA;EACA,iCAAA;EACA,eAAA;AALhB;AAOgB;EACI,gCAAA;AALpB;AAQgB;EACI,yBAAA;AANpB;AASgB;EACI,iBAAA;AAPpB;AAUgB;EACI,6BAAA;AARpB;AAYY;EACI,eAAA;AAVhB;AAYgB;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,6BAAA;EACA,eAAA;AAVpB;AAagB;EACI,aAAA;EACA,8BAAA;EACA,gCAAA;EACA,mBAAA;EACA,6BAAA;EACA,2CAAA;EACA,mCAAA;AAXpB;AAaoB;EACI,uBAAA;EACA,YAAA;EACA,2CAAA;EACA,oCAAA;EACA,mCAAA;EACA,6BAAA;EACA,sBAAA;EAEA,iDAAA;EAOA,6BAAA;AAlBxB;AAYwB;EAEE,wBAAA;EACA,SAAA;AAX1B;AAewB;EACE,0BAAA;AAb1B;AAiBoB;EACI,eAAA;AAfxB;AAiBwB;EACI,UAAA;EACA,oBAAA;EACA,eAAA;AAf5B;AAoBgB;EACI,eAAA;EACA,cAAA;EACA,kBAAA;AAlBpB;AAqBgB;EACI,gBAAA;EACA,eAAA;EACA,6BAAA;AAnBpB;AAwBQ;EACI,yBAAA;EACA,gBAAA;EACA,eAAA;AAtBZ;AAwBY;EACI,eAAA;AAtBhB;AAwBgB;EACI,qBAAA;AAtBpB;AA0BY;EACI,eAAA;AAxBhB;AA2BY;EACI,aAAA;AAzBhB","sourcesContent":["geo-search {\n    font-family: var(--text-font);\n\n    .geo-search {\n        height: initial;\n        background-color: var(--motes-off-white);\n        padding: var(--motes-padding);\n        box-sizing: border-box;\n        border-radius: var(--border-radius);\n        width: 450px;\n\n        .address-input {\n            position: relative;\n            height: 40px;\n\n            .input {\n                width: 100%;\n                border-radius: var(--border-radius);\n                border: solid 1px var(--motes-lighter-gray);\n                background-color: var(--motes-white);\n                padding: var(--motes-padding);\n                box-sizing: border-box;\n                font-size: 16px;\n\n                input {\n                    border: none;\n                    background-color: transparent;\n                    width: calc(100% - 45px);\n                }\n            }\n\n            svg-icon {\n                position: absolute;\n                top: 0;\n                right: 0;\n                height: 100%;\n                display: flex;\n                align-items: center;\n                margin: 0 var(--element-spacing);\n            }\n        }\n\n        mini-loading {\n            display: flex;\n            justify-content: center;\n            padding-right: 40px;\n            position: absolute;\n            top: 0;\n            right: 0;\n            height: 100%;\n        }\n\n        .drawer {\n            padding: 0 var(--motes-padding);\n            overflow: hidden;\n            max-height: 0;\n            transition: 0.3s max-height;\n\n            &.open {\n                transition: 0.3s max-height 0.3s;\n                max-height: 600px;\n            }\n\n            .drawer-item {\n                overflow: hidden;\n                text-overflow: ellipsis;\n                font-size: 12px;\n                border-radius: var(--border-radius);\n                padding: var(--motes-padding);\n                background-color: inherit;\n                transition: 0.2s background-color;\n                cursor: pointer;\n\n                &:first-of-type {\n                    margin-top: var(--motes-padding);\n                }\n\n                &.active-address {\n                    background-color: #d4d4d4;\n                }\n\n                svg-icon[name=\"destination\"] {\n                    margin-right: 4px;\n                }\n\n                button {\n                    background-color: transparent;\n                }\n            }\n\n            .coords-container {\n                cursor: default;\n\n                button {\n                    display: flex;\n                    align-items: center;\n                    font-size: 12px;\n                    border: none;\n                    padding: 0;\n                    font-family: var(--text-font);\n                    cursor: pointer;\n                }\n\n                .coords {\n                    display: flex;\n                    justify-content: space-between;\n                    margin-top: var(--motes-padding);\n                    align-items: center;\n                    padding: var(--motes-padding);\n                    background-color: var(--motes-lighter-gray);\n                    border-radius: var(--border-radius);\n\n                    input {\n                        width: calc(50% - 16px);\n                        height: 43px;\n                        border: solid 1px var(--motes-lighter-gray);\n                        background-color: var(--motes-white);\n                        border-radius: var(--border-radius);\n                        padding: var(--motes-padding);\n                        box-sizing: border-box;\n\n                        /* Hide arrows from Chrome, Safari, Edge, Opera */\n                        &::-webkit-outer-spin-button,\n                        &::-webkit-inner-spin-button {\n                          -webkit-appearance: none;\n                          margin: 0;\n                        }\n\n                        /* Hide arrows from Firefox */\n                        &[type=number] {\n                          -moz-appearance: textfield;\n                        }\n                    }\n\n                    svg-icon {\n                        font-size: 16px;\n\n                        &.hide {\n                            opacity: 0;\n                            pointer-events: none;\n                            cursor: default;\n                        }\n                    }\n                }\n\n                .tip {\n                    font-size: 12px;\n                    line-height: 1;\n                    margin: 10px 0 0 0;\n                }\n\n                .error {\n                    margin-bottom: 0;\n                    font-size: 12px;\n                    color: var(--motes-light-red);    \n                }\n            }\n        }\n\n        svg-icon {\n            color: var(--motes-black);\n            transition: 0.2s;\n            font-size: 16px;\n\n            &.button {\n                cursor: pointer;\n\n                &:hover {\n                    transform: scale(1.1);\n                }\n            }\n\n            &[name=\"x\"] {\n                font-size: 14px;\n            }\n\n            span {\n                display: flex;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
